<template>
  <div class="bg-indigo-600 px-16 py-12">
    <div class="max-w-5xl mx-auto space-y-8">
      <div class="flex -mx-4">
        <div class="w-1/4 px-4">
          <slot />
        </div>
        <div class="flex-1 px-4">
          <h3 class="text-white">
            {{ title }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
